<template>
  <div>
    <LDBsTable
      ref="costMaterialTransportationTable"
      id="costMaterialTransportationTable"
      url="costmaterialtransportation"
      defaultSort="createdAt"
      defaultOrder="desc"
      :query="queryToUse"
      :columns="columns"
      :clear="clear"
      :defaultOptions="options"
    >
      <div class="form-group col-lg-4">
        <label for="send_date_start">{{ $t("send_date_start") }}</label>
        <input
          type="date"
          id="send_date_start"
          name="send_date_start"
          class="form-control"
          :placeholder="$t('ph_send_date_start')"
          v-model="query.sendDateStart"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="send_date_end">{{ $t("send_date_end") }}</label>
        <input
          type="date"
          id="send_date_end"
          name="send_date_end"
          class="form-control"
          :placeholder="$t('ph_send_date_end')"
          v-model="query.sendDateEnd"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="send_method">{{ $t("send_method") }}</label>
        <Combobox
          class="bg-white"
          name="send_method"
          :placeholder="$t('select_a_item')"
          label="name"
          :options="shippingMethodTransportation"
          :initial-value="query.sendMethod"
          v-model="query.sendMethod"
          :reduce="(sendMethod) => sendMethod.id"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="send_destiny">{{ $t("send_destiny") }}</label>
        <Combobox
          class="bg-white"
          name="send_destiny"
          :placeholder="$t('select_a_item')"
          label="name"
          :options="shippingDestinyTransportation"
          :initial-value="query.sendDestiny"
          v-model="query.sendDestiny"
          :reduce="(sendDestiny) => sendDestiny.id"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="service">{{ $t("services") }}</label>
        <Combobox
          class="bg-white"
          name="service"
          :placeholder="$t('select_a_item')"
          label="name"
          :options="serviceTypes"
          :initial-value="query.service"
          v-model="query.service"
          :reduce="(service) => service.id"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="client">{{ $t("client") }}</label>
        <Combobox
          class="bg-white"
          name="client"
          :placeholder="$t('select_a_item')"
          label="nome_cliente"
          :options="financialClients"
          :initial-value="query.client"
          :reduce="(client) => client.id"
          v-model="query.client"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="group_by">{{ $t("group_by") }} <small><em>(Apenas para relatório)</em></small></label>
        <Combobox
          class="bg-white"
          name="group_by"
          :placeholder="$t('select_a_item')"
          label="text"
          :options="groupByOptions"
          :initial-value="groupBy"
          :reduce="(groupBy) => groupBy.value"
          v-model="groupBy"
        />
      </div>
    </LDBsTable>

    <!-- MODAL DELETE COST -->
    <div
      class="modal
      fade"
      id="modalDeleteCost"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalDeleteCostLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalDeleteCostLabel">Cancelar Custo</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <p>Deseja realmente remover este custo?</p>
            <ul v-if="itemToDelete">
              <li><strong>Data de Envio:</strong> {{ formatDate(itemToDelete.sendDate) }}</li>
              <li><strong>Forma de Envio:</strong> {{ itemToDelete.sendMethod.name }}</li>
              <li><strong>Destino de Envio:</strong> {{ itemToDelete.sendDestiny.name }}</li>
              <li><strong>Serviço:</strong> {{ itemToDelete.service.name }}</li>
              <li><strong>Cliente:</strong> {{ itemToDelete.client.name }}</li>
              <li>
                <strong>Custo:</strong>
                {{ formatCurrency(itemToDelete.coast) }}
              </li>
            </ul>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">{{ $t('close') }}</button>
            <button type="button" class="btn btn-danger" @click="deleteItem" data-dismiss="modal">{{ $t('yes') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import LDBsTable from "@/components/shared/LDBsTable";
import Combobox from "@/components/shared/ComboBox";
import LoaderButton from "@/components/button/LoaderButton";
import axios from "axios";
import { baseUrlReports } from "@/lib/config";

export default {
  name: "ReportCostMaterialTransportation",
  components: {
    LDBsTable,
    Combobox,
    LoaderButton,
  },

  data() {
    return {
      itemToDelete: null,
      columns: [
        {
          title: this.$t("send_date"),
          field: "sendDate",
          formatter: (value) => {
            const [year, month, day] = value.split('-')

            return `${day}/${month}/${year}`
          },
        },
        {
          title: this.$t("send_method"),
          field: "sendMethod",
          formatter: (value) => value.name,
        },
        {
          title: this.$t("send_destiny"),
          field: "sendDestiny",
          formatter: (value) => value.name,
        },
        {
          title: this.$t("services"),
          field: "service",
          formatter: (value) => value.name,
        },
        {
          title: this.$t("client"),
          field: "client",
          formatter: (value) => value.name,
        },
        {
          title: this.$t("coast"),
          field: "coast",
          formatter: (value) => {
            return new Intl.NumberFormat("pt-BR", {
              style: "currency",
              currency: "BRL",
            }).format(value);
          },
        },
        {
          key: "id",
          field: "id",
          align: "center",
          width: "100%",
          formatter: function (value) {
            return `
              <a
                href="#/main/reportcostmaterialtransportation/${value}"
                class="edit btn btn-action btn-primary btn-circle light-bottom-shadow text-white"
              >
                <i class="fas fa-pen" />
              </a>
              <button
                title="Remover"
                data-field="delete"
                class="btn btn-action btn-danger btn-circle light-bottom-shadow text-white"
              >
                <i class="fas fa-trash" />
              </button>
            `;
          },
        },
      ],
      options: {
        exportOptions: { fileName: "Custo com Transporte de Material" },
      },
      query: {
        sendDateStart: '',
        sendDateEnd: '',
        sendMethod: null,
        sendDestiny: null,
        service: null,
        client: null
      },
      queryToUse: {},
      clients: [],
      groupBy: null,
      groupByOptions: [
        { text: 'Forma de Envio', value: 'send_method' },
        { text: 'Destino de Envio', value: 'send_destiny' },
        { text: 'Serviço', value: 'service' },
        { text: 'Cliente', value: 'client' }
      ]
    };
  },

  computed: {
    ...mapState({
      financialClients: (state) => state.financial.clients,
      shippingMethodTransportation: (state) => state.shippingmethodtransportation.all,
      shippingDestinyTransportation: (state) => state.shippingdestinytransportation.all,
      serviceTypes: (state) => state.servicetypes.all,
      lastquery: (state) => state.filtershistory.query,
      user: (state) => state.session.user,
    })
  },

  methods: {
    ...mapActions('costmaterialtransportation', ['deleteCost']),

    formatDate(value) {
      if (!value) return ''

      const [year, month, day] = value.split('-')
      return `${day}/${month}/${year}`
    },

    formatCurrency(value) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value);
    },

    clear() {
      this.query.sendDateStart = ''
      this.query.sendDateEnd = ''
      this.query.sendMethod = null
      this.query.sendDestiny = null
      this.query.service = null
      this.query.client = null
      this.groupBy = null
      this.reportType = null
    },

    handleModalDeleteCost() {
      const { admin, tags } = this.user

      if (admin || tags.includes('delete_cost_material_transportation')) {
        $('#modalDeleteCost').modal('show');

        return;
      }

      this.$store.dispatch(
        "notify/error",
        { message: "Você não tem permissão para remover custos." },
        { root: true }
      );
    },

    async deleteItem() {
      const deleted = await this.deleteCost(this.itemToDelete.id);

      if (deleted) {
        this.itemToDelete = null;

        $('#search').trigger('click')
      }
    },

    async generateReport() {
      const { dispatch } = this.$store;

      try {
        dispatch('overlay/show', true)

        const newQuery = Object.entries(this.queryToUse).reduce(
          (acc, [key, value]) => {
            if (value !== "") {
              acc[key] = value;
            }

            return acc;
          },
          {}
        );

        if (!newQuery.sendDateStart || !newQuery.sendDateEnd) {
          dispatch(
            "notify/error",
            { message: "Informe pelo menos o intervalo de Datas" },
            { root: true }
          );

          return;
        }

        // PEGA A ESTRUTURA JSON DO PDF
        const pdfStructure = await dispatch(
          "costmaterialtransportation/generateReport",
          { ...newQuery, groupBy: this.groupBy }
        );

        // FAZ REQUISIÇÃO AO MICROSERVIÇO DE GERAÇÃO DO PDF
        if (pdfStructure) {
          axios({
            url: baseUrlReports(),
            method: "post",
            data: pdfStructure,
            responseType: "blob",
          })
            .then((response) => {
              const file = new Blob([response.data], { type: "application/pdf" });
              const fileURL = URL.createObjectURL(file);
              window.open(fileURL, "_blank");
            })
            .catch((error) => {
              console.log(error);
            })
            .then((busy) => {
              $("#table").bootstrapTable("hideLoading");
              $("#modalLoading").modal("hide");
            });
        } else {
          $("#table").bootstrapTable("hideLoading");
          $("#modalLoading").modal("hide");

          dispatch(
            "notify/error",
            { message: "errorWhenPrintingActivesMovement" },
            { root: true }
          );
        }
      } catch (error) {
        console.log('[ERROR-GENERATE-REPORT] => ', error);
      } finally {
        dispatch('overlay/show', false)
      }
    },
  },

  beforeMount() {
    this.queryToUse = this.lastquery["costmaterialtransportation"]
      ? this.lastquery["costmaterialtransportation"]
      : this.query;
  },

  async mounted() {
    const { dispatch } = this.$store;

    await Promise.all([
      dispatch("financial/fetchClients"),
      dispatch("shippingmethodtransportation/fetchAll"),
      dispatch("shippingdestinytransportation/fetchAll"),
      dispatch("servicetypes/fetchAll"),
    ])

    if (this.lastquery["costmaterialtransportation"]) {
      for (const [key, value] of Object.entries(this.lastquery["costmaterialtransportation"])) {
        this.query[key] = value;
      }
    }

    this.queryToUse = this.query;

    const global = this;

    $("#toolbar").find("div:first").append(`
        <button
          id="buttonGenerateReport"
          class="btn btn-primary text-white right"
          aria-expanded="true"
        >
          ${this.$t("generate_report")}
        </button>
      `);

    $("#buttonGenerateReport").on("click", function () {
      global.generateReport();
    });

    const table = $(this.$refs.costMaterialTransportationTable.$el).find('table');
    table.on('click-cell.bs.table', function (e, field, value, row, $element) {
      if (field === 'id' && $($element).find('[data-field="delete"]').length) {
        global.itemToDelete = row;
        global.handleModalDeleteCost()
      }
    });
  },

  destroyed() {
    const { dispatch } = this.$store;

    dispatch("servicetypes/cleanState");
    dispatch("shippingmethodtransportation/cleanState");
    dispatch("shippingdestinytransportation/cleanState");
    dispatch("financial/cleanState");
    dispatch("filtershistory/setQuery", {
      key: "costmaterialtransportation",
      query: this.query,
    });
  },
};
</script>
